import restClient from "api/restClient";

/**
 * Run a GraphQL request and surface GraphQL-level errors (HTTP 200 with an
 * `errors` array, e.g. a permission refusal) as a rejected promise, so the
 * caller shows them like any other failed request.
 */
export const zoneGraphql = async (query: string, variables: Record<string, unknown>) => {
    const response = await restClient.post("graphql", { query, variables });
    const errors = response?.data?.errors;
    if (errors?.length) {
        throw new Error(errors.map((e: { message?: string }) => e.message).join("; "));
    }
    // The workspace GraphQL endpoint returns the selection set at the top level.
    return response?.data;
};
